// extracted by mini-css-extract-plugin
export default {"orPosition":"orPosition_SwL-R","testBlockWidth700":"testBlockWidth700_2KlKw"};